<app-header [showBack]="true"></app-header>
<app-set-meta title="利用規約｜Forbes CAREER"></app-set-meta>

  <!-- <app-tab-menu></app-tab-menu> -->
  	<div class="term-body">
  		<h1>Forbes JAPAN CAREER 利用規約</h1>
	    <p>
	        「このForbes JAPAN CAREER利用規約（以下、「本規約」といいます）は、リンクタイズ株式会社（以下、「当社」といいます）が提供する本サービス（第1条において定義します）の利用者たる会員（第1条において定義します）との関係を規律します。
	    </p>
	    <h4>第1条（適用の範囲）</h4>
	    <p>本規約は、当社が運営するForbes JAPAN CAREER（以下、「本サイト」といいます）上で提供されるサービス（以下、「本サービス」といいます）に関し、第3条第2項に従って会員登録を行った会員（以下、「会員」といいます）に対して、当該会員登録の時点から、適用されます。会員は、当該会員登録をもって、本規約及び当社が定めるプライバシーポリシー（以下、併せて「本規約等」といいます）に同意したものとみなします。</p>
	    <h4>第2条（必要環境）</h4>
	    <p>
	        本サービスの利用には、インターネットへの接続が必要です。通信料金は会員が負担するものとします。</p>
	    <h4>第3条（本サービスの利用）</h4>
	    <div>
	        <ol>
	            <li>
	                本サービスは、本規約等のほか、適用される法令等を遵守している会員に限り、利用することができるものとします。未成年の方は、次項に従って会員登録を行った時点において、保護者（法定代理人）から、本規約等を遵守の上で本サービスを利用する許可を得ていることを表明し、保証したものとみなします。
	            </li>
	            <li>
	                会員となることを希望する者は、本規約等の内容に同意した上で、当社所定の方法により、会員登録の手続きを行い、自身のアカウント（以下、「本アカウント」といいます）を作成するものとします。なお、会員登録に際しては、以下の各号を遵守するものとします。
	            </li>
	            <ol>
	                <li>登録するID、パスワードその他の会員にかかる情報は、自己の責任において大切に保管し、他人に知られることがないよう機密として厳重に保持するものとします。</li>
	                <li>登録する電話番号、住所や電子メールアドレスその他の連絡先情報に対して、当社からのお知らせや広告等の連絡に供されること（登録した端末にプッシュ通知が送信される可能性があることを含みます）を了承し、それら連絡先情報について、当社からの連絡を必ず受け取ることができるものを選択するとともに、その受取可能な状態を維持するものとします。</li>
	                <li>権限のない者により本アカウントが利用された可能性があると認識した場合、ただちに当社に通知するものとします。</li>
	            </ol>
	            
	            <li>当社は、会員が以下の各号に該当すると判断した場合、事前の通知・催告等を経ることなく、当該会員による本アカウントの恒久的又は一時的な利用制限や削除、当該会員による本サービスの恒久的又は一時的な利用停止、当該会員による本サイトへのアクセスの恒久的又は一時的な停止等の措置（以下、併せて「利用制限等措置」といいます）を講じることができるものとします。なお、当社は、利用制限等措置を講じる義務を負うものではありません。</li>
	            <ol>
	                <li>本規約等に違反した場合。</li>
	                <li>死亡した場合又は後見開始、補佐開始若しくは補助開始の審判を受けた場合。</li>
	                <li>過去に利用制限等措置を講じられたことがある場合（第9条第④号による当社許可の有無を問いません）。</li>
	                <li>本アカウントが権限のない者により利用された形跡がある場合（第2項第③号による会員からの通知の有無を問いません）。</li>
	                <li>暴力団、暴力団員、暴力団準構成員、総会屋、社会運動等標榜ゴロ、特殊知能暴力集団その他これに準じる反社会的勢力（以下、併せて「反社会的勢力等」といいます）であると判明した場合、又は資金提供その他の行為を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与をしている場合。</li>
	                <li>上記の他、利用制限等措置が適切であると判断した場合。</li>
	            </ol>
	        </ol>
	    </div>
	    <h4>第4条（登録の解除等）</h4>
	    <div>
	        <ol>
	            <li>
	                会員が、会員登録した内容の変更又は会員登録の解除を希望する場合、当社指定の方法により、会員本人が手続きを行うものとします。
	            </li>
	            <li>
	                会員は、会員登録の解除、利用制限等措置、次条による本サービスの変更等その他の理由により本アカウント上の情報及びプロフィール（第7条において定義します）の全部又は一部が削除されることがあることを了承します。但し、当社は、いかなる場合においても、かかる削除の義務を負うものではありません。
	            </li>
	        </ol>
	    </div>
	    <h4>第5条（本サービスの変更・停止・終了）</h4>
	    <p>
			本サービスは、事前の通知等を経ることなく、その全部若しくは一部の提供が終了、停止又は変更されることがあり、また、本サービスの利用に新たな制約が課されることがあります。	    
		</p>
	    <h4>第6条（私的使用）</h4>
	    <p>会員は、本サイト上のコンテンツ（以下、「本コンテンツ」といいます）について、自身の私的使用のみを目的として閲覧するものとします。</p>
	    <h4>第7条（プロフィールの登録）</h4>
	    <div>
	        <ol>
	            <li>
	                会員は、当社の定める基準に従って、自己の責任と判断において本サービス上で自身の職歴等の情報（以下、併せて「プロフィール」といいます）を設定するものとします。
	            </li>
	            <li>
	                会員は、プロフィールを設定するに際して、当社が明示的に指定した入力欄以外に、自己又は第三者の個人に関する情報（住所、メールアドレス、電話番号等を含みます。以下同じ）を記載してはならないものとし、かかる明示的に指定した入力欄以外に個人に関する情報が含まれていた場合には、当社は、当該部分を削除又は修正することができます。但し、当社は、かかる削除等の義務を負うものではありません。
	            </li>
	            <li>
	                会員は、プロフィールに変更が生じた場合には、前各項を遵守しつつ、直ちに修正を行うものとします。
	            </li>
	            <li>
	                当社は、プロフィールが当社の定める基準に反する又は事実に反すると判断した場合には、当該会員に対して当該プロフィールの削除若しくは訂正を求め又は当該会員のプロフィールの公開範囲を変更し若しくは非公開にすることができます。但し、当社は、かかる削除を求める等の義務を負うものではありません。
	            </li>
			</ol>
	    </div>
	    <h4>第8条（著作権等）</h4>
	    <p>
			本サービスに関わる著作権、商標権その他の知的財産権及びその他の権利等の財産権（本コンテンツにかかるものを含め、以下、併せて「知的財産権等」といいます）はすべて、当社又は正当な権利を有する第三者に帰属します。	    
		</p>
	    <h4>第9条（遵守事項）</h4>
	    <div>
	        <p>会員は、本サービスの利用にあたり、以下の行為を自ら行わず、また、第三者をして行わせないものとします。</p>
            <ol>
                <li>会員登録手続きに際して虚偽の情報を提供すること。</li>
                <li>当社の書面による承諾なくして、他人名義のアカウントを作成すること。</li>
                <li>本アカウントを複数作成すること。</li>
                <li>利用制限等措置を講じられた後、当社の書面による承諾なくして、新たな本アカウントを作成すること。</li>
                <li>
                    本アカウントにかかるID・パスワードの他人との共有、他人に対する本アカウントの譲渡、他人に対する本アカウントへのアクセスの許可等の本アカウントを利用させる行為その他の本アカウントのセキュリティを脅かす恐れのある行為。
                </li>
                <li>本コンテンツを商業目的で閲覧し若しくは不特定多数の者の閲覧に供すること又は本コンテンツを著作権法で認められた私的使用の範囲を超えて、複製、出版、公表、譲渡、公衆送信、改変その他の態様で利用すること。</li>
                <li>自動化された手段(情報収集ボット、ロボット、スパイダー、スクレーパーなど)を使用して、本アカウント作成し又は本アカウントにアクセスすること。</li>
                <li>当社又は正当な権利を有する権利者の著作権、商標権その他の知的所有権及びその他の財産権を侵害する行為若しくはそれらを侵害する恐れのある行為。</li>
                <li>本サービスの提供にかかわり使用される当社又は第三者の通信設備、コンピューターその他の機器若しくはソフトウェアに不正にアクセスすること、又は、それらの利用若しくは運用に支障を与える行為又は与える恐れのある行為。</li>
                <li>当社の書面による承諾なくして、当社の商号、商標及びロゴ並びに当社ウェブサイト（本サイトに限りません）上の情報（本サービスの名称や本サービスにかかる資料を含みます）、レイアウト及びデザイン等のコンテンツ（本コンテンツに限りません）の全部若しくは一部を使用、表示、ミラー、フレームすること又はフレーム技術を使用してエンクローズすること。</li>
                <li>不正な商用メッセージ(迷惑メールなど)を投稿すること。</li>
                <li>ピラミッド商法など、非合法なマルチ商法などを実施すること。</li>
                <li>特定の宗教団体や宗教活動へ勧誘すること。</li>
                <li>ウイルス又はその他の悪質なコードをアップロードすること。</li>
                <li>他の会員のログイン情報を求めること又は他人のアカウントにアクセスすること。</li>
                <li>当社のソースコードについて改変、派生物の作成、デコンパイルその他の操作をすること。</li>
                <li>法令に違反する行為、本規約等の違反を助長又は推奨する行為、本サービスの運営を妨害する行為、当社の信用を毀損し若しくは当社の財産を侵害する行為その他の当社に不利益を与える行為。</li>
            	<li>上記各号のほか、当社が本サービスの利用目的から鑑みて不適切と判断する行為。</li>
			</ol>
	    </div>
	    <h4>第10条（情報保護）</h4>
	    <p>
			本サービスにおいて会員が会員登録した情報は、当社が定めるプライバシーポリシー（https://linkties.com/privacy/）に基づき適切に取り扱います。なお、会員は、会員登録した情報及びプロフィールが、当社より本サービスにおいて求人等の広告を掲載する企業等に提供されるものであることに同意します。	    
		</p>
	    <h4>第11条（免責）</h4>
	    <div>
	        <ol>
	            <li>当社は、会員に対し、本サイトの一切の動作保証を行わず、いかなる責任も負いません。</li>
	            <li>本サービスにおいて提供される情報（企業情報及び求人情報を含みます）の完全性、真実性、正確性、合法性等（以下、併せて「情報の完全性等」といいます）に当社は一切の責任を負いません。</li>
	            <li>当社は、会員に対し、本サービス及び本コンテンツが第三者の知的財産権等を侵害していないことを保証するものではありません。</li>
	            <li>当社は、天災地変その他の不可抗力（回線の輻輳、回線の障害、サーバーダウン、郵便事故等を含みますが、これらに限られません）にかかわり会員に生じた損失につき、何らの責任も負わないものとします。</li>
			</ol>
	    </div>
	    <h4>第12条（無保証）</h4>
	    <div>
	        <ol>
	            <li>
	                本サービスで提供される企業情報及び求人情報は､提供元である第三者（以下「掲載企業等」といいます）の責任で提供されるものであり､当社は、それら情報の完全性等及びそれら情報にかかる企業等の信用性を検証し、また、保証するものではありません｡また、当社は、掲載企業等と会員との連絡等に関与するものではなく、掲載企業等による会員の採否や掲載企業等への入社等につき、何らの責任も負わないものとします。
	            </li>
	            <li>前項のほか、当社は、本サービスを利用することにかかわり､会員と第三者との間に生じた紛争や会員に生じた損害につき､何らの責任も負わないものとします｡</li>
	            <li>
	                当社は、Facebook等の外部サービス（以下、「外部サービス」といいます）と本サービスとの連携を保証するものではなく、外部サービスのサービス内容若しくは運用の変更又は本サービスの内容若しくは運用の変更によって、外部サービスを通じた本サービスの全部又は一部の利用が制限されたとしても、何らの責任も負わないものとします。
	            </li>
				<li>会員は、自己の責任において外部サービスを利用するものとし、当社は、外部サービスを利用したことにかかわり、会員と当該サービスの運営者・利用者等との間に生じた紛争や会員に生じた損害その他の外部サービスに関連する一切の事項につき、何らの責任も負わないものとします。</li>
	        </ol>
	    </div>
	    <h4>第13条（外部サービスの利用）</h4>
	    <div>
	        <ol>
	            <li>会員が外部サービスとの連携機能を利用して本アカウントにログインする際に、当社がデータにアクセスすることについての許可を求められた場合には、当社は、これを許可することができるものとします。但し、当社は、かかる許可をする義務を負うものではありません。</li>
	            <li>外部サービスの利用について、会員は、外部サービスの運営者が規定する各規約の定めに従うものとします。</li>
	        </ol>
	    </div>
	    <h4>第14条（本規約の変更）</h4>
	    <div>
	        <ol>
	            <li>当社は、当社が必要と判断する場合、事前の通知等を経ることなく、本規約の変更を行うことができるものとします。</li>
	            <li>
	                当社は、変更後の本規約を本サイト又は会員に別途通知するウェブサイト上で公開します。本規約の変更後も会員が本サービスの利用を継続する場合には、規約が公開された時点から変更後の利用規約に同意したものとみなします。
	            </li>
	        </ol>
	    </div>
	    <h4>第15条（準拠法）</h4>
	    <p>本規約は、日本法に準拠し、日本法に基づき解釈されます。</p>
	    <h4>第16条（専属的合意管轄裁判所）</h4>
	    <p>本規約に関する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
	</div>
  <app-footer></app-footer>

<!-- /.wrapper -->
